import React, { useState, useEffect } from "react";
import useMobile from "hooks/useMobile";
import { useDispatch } from "react-redux";
import { toastAlert } from "@paylixecommerce/shared/components";
import { Text } from "components/fields";
import { Link } from "react-router-dom";
import { getCustomersShopAction } from "../../../actions";
import { Select } from "components";
import config from "constants/config";



export default ({ form, isUtils }) => {

	const { values: { affiliate_revenue_percent, affiliate_revenue_enabled }, setFieldValue } = form;

	const dispatch = useDispatch();
	const [isAffiliateActive, setAffiliateActive] = useState(false);
	const [shopAffiliatePercent, setShopAffiliatePercent] = useState(false);
	const isMobile = useMobile();

	useEffect(() => {
		dispatch(getCustomersShopAction())
			.then((res) => {
				let { data, status } = res;
				if(status === 200) {
					setAffiliateActive(data.shop.affiliate_revenue_active);
					setShopAffiliatePercent(data.shop.affiliate_revenue_percent);
				} else {
					throw res;
				}
			})
			.catch((err) => toastAlert('error', err ? err.error : ""))
	}, [])


	return <div className={!isAffiliateActive ? "d-none" : "w-100"}>

			<label className="paylixecommerce-label">Affiliate Revenue Percent</label>

			{isMobile ?
				<div className="mb-3">
					<Select
						size="large"
						value={affiliate_revenue_enabled ? "CUSTOM" : affiliate_revenue_percent}
						options={config.AFFILIATE_TYPE_OPTIONS.map(option => ({
							label: option.label === "Default" ? `${option.label} - ${shopAffiliatePercent}%` : option.label,
							value: option.value,
						}))}
						onChange={(e) => {
							if(e.target.value === "CUSTOM") {
								setFieldValue("affiliate_revenue_enabled", true);
								setFieldValue("affiliate_revenue_percent", "");
							} else {
								setFieldValue("affiliate_revenue_percent", e.target.value);
								setFieldValue("affiliate_revenue_enabled", false);
							}
						}}
					/>
				</div>
				:
				<div className="type-widget">
					<div>

						{config.AFFILIATE_TYPE_OPTIONS.map(({ value, label }) =>
							<button
								style={{ width: "33%" }}
								key={label}
								type="button"
								className={
									(affiliate_revenue_percent === value || (affiliate_revenue_enabled && value !== 0 && value !== -1)) ?
										"active" : ""
								}
								onClick={() => {
									if(value === "CUSTOM") {
										setFieldValue("affiliate_revenue_enabled", true);
										setFieldValue("affiliate_revenue_percent", "");
									} else {
										setFieldValue("affiliate_revenue_enabled", false);
										setFieldValue("affiliate_revenue_percent", value);
									}
								}}
							>
								{label} {label === "Default" ? ` - ${shopAffiliatePercent}%` : null}
							</button>
						)}
					</div>
				</div>
			}

			<div className={`paylixecommerce-note ${isUtils ? "" : "mb-3 pb-3"}`} style={{ borderBottom: isUtils ? "" : affiliate_revenue_enabled ? "" : "1px solid var(--black1)" }}>
				<>Decide how much of the total of this product will be added to the customer's balance in their affiliate dashboard. This value will overwrite your <Link target="_blank" to={"/settings/shop/affiliate"}>default setting</Link>.</>
			</div>


			{affiliate_revenue_enabled ?
				<div className="mb-4 mt-3" style={{ borderBottom: isUtils ? "" : "1px solid var(--black1)" }}>
					<div className="position-relative">
						<div className="paylixecommerce-input-prefix" style={{ top: 0 }}>
							%
						</div>
						<Text
							min={-1}
							rows={3}
							label=""
							type="number"
							tooltip=""
							placeholder="0"
							name="affiliate_revenue_percent"
							{...form}
						/>
					</div>
				</div>
				: null
			}
		</div>

}